import React from 'react'
import {
  AspectRatio,
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react'

import {createVideoURL} from '../../utils'
import copy from './copy.json'

// Staff-access walkthrough video. createVideoURL accepts any standard
// YouTube/Vimeo watch URL and normalizes it to the embeddable form.
const VIDEO_URL = 'https://youtu.be/Zd4rO1AtrPA'

interface Props {
  isOpen: boolean
  onClose: () => void
}

export const HowItWorksVideoModal: React.FC<Props> = ({isOpen, onClose}) => {
  // Normalize the watch URL to the embeddable form the same way the
  // micropost feed does (utils/createVideoURL → https://www.youtube.com/embed/<id>).
  const embedUrl = createVideoURL(VIDEO_URL)

  return (
    <Modal isOpen={isOpen} onClose={onClose} size='3xl' isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader paddingRight={10}>{copy.video.modalTitle}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          {embedUrl ? (
            <Box overflow='hidden' borderRadius={3}>
              <AspectRatio ratio={16 / 9}>
                <iframe
                  title={copy.video.modalTitle}
                  src={embedUrl}
                  // Required: prevents YouTube Error 153 when the page
                  // Referrer-Policy is restrictive (AB#19301). Mirrors the
                  // micropost video embed in MicropostItem/ItemMedia.tsx.
                  referrerPolicy='strict-origin-when-cross-origin'
                  allowFullScreen
                  width='100%'
                  height='100%'
                />
              </AspectRatio>
            </Box>
          ) : null}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
